export default {"src":"/_next/static/media/app-store.4c22843e.svg","height":40,"width":201,"blurWidth":0,"blurHeight":0};